import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">People<span>ology</span></Link>
          <p>Strategic people &amp; business consulting for boutique real estate agencies across Australia. Bold. Deliberate. Matter-of-fact.</p>
          <span className="footer-tag" style={{marginTop:'1rem',display:'inline-block'}}>Based in Melbourne · Placing Australia wide</span>
        </div>
        <div className="footer-col">
          <h5>Explore</h5>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/recruitment">Recruitment</Link></li>
            <li><Link to="/speaking">Speaking</Link></li>
            <li><Link to="/about">About</Link></li>
          </ul>
        </div>
        <div className="footer-col">
          <h5>Services</h5>
          <ul>
            <li><Link to="/services">Strategic Review</Link></li>
            <li><Link to="/recruitment">Recruitment</Link></li>
            <li><Link to="/services">Remuneration Benchmarking</Link></li>
            <li><Link to="/services">Culture &amp; Growth</Link></li>
            <li><Link to="/speaking">Workshops</Link></li>
          </ul>
        </div>
        <div className="footer-col">
          <h5>Contact</h5>
          <ul>
            <li><a href="mailto:hello@peopleology.co">hello@peopleology.co</a></li>
            <li><a href="https://www.linkedin.com/in/peopleology/" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
            <li><Link to="/contact">Book a call</Link></li>
            <li><Link to="/contact">Send a message</Link></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Peopleology. All rights reserved.</p>
        <div style={{display:'flex',gap:'1.75rem',flexWrap:'wrap',alignItems:'center'}}>
          <Link to="/privacy" className="footer-legal-link">Privacy Policy</Link>
          <Link to="/terms" className="footer-legal-link">Terms of Service</Link>
          <p>Geelong · Melbourne · Greater Victoria</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
